import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { setCookie } from "./utils"

import './registerServiceWorker'
import {
  Button, Select, InputNumber, Card, Checkbox, CheckboxButton, CheckboxGroup, Input, Form,
  FormItem, Radio,RadioGroup,Cascader,Dialog,Message,Loading,Row,MessageBox,Pagination,Tabs,TabPane,
} from 'element-ui';

Vue.use(Button)
Vue.use(InputNumber)
Vue.use(Select)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Cascader)
Vue.use(Dialog)
Vue.use(Row)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(TabPane)
// Vue.use(Message)
// Vue.use(Loading)


import { Button as VanButton } from 'vant';
import { Icon as VanIcon } from 'vant';
import { Swipe as VanSwipe, SwipeItem as VanSwipeItem } from 'vant';
import { Tag as VanTag } from 'vant';
import {Popup as VanPopup } from 'vant';
import { Stepper as VanStepper } from 'vant';
import { Toast as VanToast } from 'vant';
import { Loading as VanLoading } from 'vant';
import { List as VanList } from 'vant';
import { Tab as VanTab, Tabs as VanTabs} from 'vant';

Vue.use(VanTab).use(VanTabs);
Vue.use(VanList);
Vue.use(VanLoading);
Vue.use(VanToast);
Vue.use(VanStepper);
Vue.use(VanTag);
Vue.use(VanSwipe)
Vue.use(VanSwipeItem);
Vue.use(VanIcon);
Vue.use(VanButton);
Vue.use(VanPopup);

import './assets/css/App.css'
import './assets/iconfont/iconfont.css'

Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {

  if (to.query.referer) {
    setCookie("referer", to.query.referer, true);
  }
  if(navigator.userAgent.match(/MicroMessenger/i) == 'MicroMessenger' && store.state.wechat.wechatauthor.openid == undefined && to.path != '/mobile/wechat/author'){
    setCookie("topath", to.path, true);      
    next('/mobile/wechat/author')
  }
  if (to.path) {
    window._hmt = window._hmt || []
    window._hmt.push(['_trackPageview', to.fullPath])
  }
  if (window.document.title) {
    window.document.title = to.meta.title;
    next();
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
